import { createPortal } from "react-dom";
import "./UsmRiskSchoolsModal.css";
import "./AnalyticsWatchAreasModal.css";

const AnalyticsWatchAreasModal = ({ open, onClose, rows = [], scopeLabel = "District scope" }) => {
  if (!open) return null;

  return createPortal(
    <div className="usm-risk-modal-overlay awa-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="usm-risk-modal awa-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="awa-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="usm-risk-modal-head">
          <div>
            <p className="usm-risk-modal-eyebrow">Executive insights · {scopeLabel}</p>
            <h3 id="awa-modal-title">Watch Areas — Indicators Below Target</h3>
            <p className="usm-risk-modal-sub">
              These KPIs are below the district readiness threshold and should be reviewed in the next
              executive briefing cycle.
            </p>
          </div>
          <button type="button" className="usm-risk-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="usm-risk-modal-body awa-modal-body">
          {rows.length === 0 ? (
            <p className="awa-empty">All core indicators are within target range.</p>
          ) : (
            <table className="usm-risk-modal-table awa-table">
              <thead>
                <tr>
                  <th>Indicator</th>
                  <th>Current</th>
                  <th>Target</th>
                  <th>Gap</th>
                  <th>Recommended action</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td className="awa-indicator">{row.label}</td>
                    <td className="awa-value">{row.value}</td>
                    <td>{row.target}</td>
                    <td>
                      <span className={`awa-tag awa-tag-${row.severity}`}>{row.gap}</span>
                    </td>
                    <td className="awa-action">{row.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AnalyticsWatchAreasModal;
